import React from "react";
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import VisibilitySensor from 'react-visibility-sensor';

import Heading3 from '../titles/Heading3';
import Paragraph from '../paragraphs/Paragraph';
import ListWithIcons from '../lists/list-icons';

class FeatureSectionItem extends React.Component {
    constructor() {
        super();
        this.state = {
            animated : false,
            animationClasses : [''],
        };
        this.headerVisible = this.headerVisible.bind(this);
    }

    headerVisible(isVisible) {
        if (isVisible) {
            if (!this.state.animated) {
                var elemIndex = this.props.index,
                timeDelay =+ elemIndex * 200;
                setTimeout(function() { 
                    var classes = this.state.animationClasses;
                    classes.push('animate-box');
                    classes.push('fadeIn');
                    classes.push('animated-fast');
                    this.setState({ animated: true, animationClasses: classes}); 
                }.bind(this), timeDelay);
            }
        }
    };
    render() {
        return (
            <VisibilitySensor partialVisibility={ true } onChange={ this.headerVisible } >
                <div className={"gtco-staff " + this.state.animationClasses.join(' ')} style={ { opacity : 0 } }>
                    <img src={ "images/"+this.props.value.image } alt={ this.props.value.name }/>
                    <Heading3 title={ this.props.value.name } subtitle= { this.props.value.jobTitle }/>
                    <Paragraph text={ this.props.value.description } />
                    <ul className="gtco-social-icons">
                        <ListWithIcons icons={ this.props.value.social }/>
                    </ul>
                </div>
            </VisibilitySensor>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(FeatureSectionItem);




// WEBPACK FOOTER //
// ./src/components/features/featuresection-item.jsx